import { Routes } from '@angular/router';
import { authGuard, roleGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'appointments', pathMatch: 'full' },
  {
    path: 'auth',
    children: [
      {
        path: 'login',
        loadComponent: () => import('./modules/main/auth/login.component').then(m => m.LoginComponent)
      }
    ]
  },
  {
    path: 'admin/reset-password',
    loadComponent: () => import('./modules/main/auth/reset-password.component').then(m => m.ResetPasswordComponent)
  },
  {
    // Public patient password reset (opened from the email reset link).
    // Canonical path is "password-reset" — chosen so it does NOT match the
    // mobile app's "/reset-password" Android App Link, so the link always opens
    // this web page in the browser (no app update needed). "reset-password" is
    // kept as a legacy alias for already-sent emails.
    path: 'password-reset',
    loadComponent: () => import('./modules/main/auth/patient-reset-password.component').then(m => m.PatientResetPasswordComponent)
  },
  {
    path: 'reset-password',
    loadComponent: () => import('./modules/main/auth/patient-reset-password.component').then(m => m.PatientResetPasswordComponent)
  },
  {
    path: 'confirm/:token',
    loadComponent: () => import('./modules/main/appointments/patient-appointment-confirm/patient-appointment-confirm.component')
      .then(m => m.PatientAppointmentConfirmComponent)
  },
  {
    path: 'privacy-policy',
    loadComponent: () => import('./modules/main/legal/privacy-policy.component')
      .then(m => m.PrivacyPolicyComponent)
  },
  {
    path: 'terms-of-service',
    loadComponent: () => import('./modules/main/legal/terms-of-service.component')
      .then(m => m.TermsOfServiceComponent)
  },
  {
    path: '',
    loadComponent: () => import('./shell/shell.component').then(m => m.ShellComponent),
    canActivate: [authGuard],
    children: [
      { path: 'patients',         loadComponent: () => import('./modules/main/patients/patients.component').then(m => m.PatientsComponent) },
      { path: 'appointments', loadComponent: () => import('./modules/main/appointments/appointments.component').then(m => m.AppointmentsComponent), data: { status: '' } },
      { path: 'treatments',       loadComponent: () => import('./modules/main/services/services.component').then(m => m.ServicesComponent), canActivate: [roleGuard('admin')] },
      { path: 'users',            loadComponent: () => import('./modules/main/users/users.component').then(m => m.UsersComponent), canActivate: [roleGuard('admin')] },
      { path: 'wayfinding',       loadComponent: () => import('./modules/main/wayfinding/wayfinding.component').then(m => m.WayfindingComponent), canActivate: [roleGuard('admin')] },
      { path: 'reminders',        loadComponent: () => import('./modules/main/reminders/reminders.component').then(m => m.RemindersComponent), canActivate: [roleGuard('admin')] },
      { path: 'messaging',        loadComponent: () => import('./modules/main/messaging/messaging.component').then(m => m.MessagingComponent), canActivate: [roleGuard('admin')] },
      { path: 'settings',         loadComponent: () => import('./modules/main/settings/settings.component').then(m => m.SettingsComponent), canActivate: [roleGuard('admin')] },
      { path: 'aftercare/questionnaires',          loadComponent: () => import('./modules/main/aftercare/questionnaires/questionnaires.component').then(m => m.AftercareQuestionnairesComponent), canActivate: [roleGuard('admin')] },
      { path: 'aftercare/questions', loadComponent: () => import('./modules/main/aftercare/questions/questions.component').then(m => m.AftercareQuestionsComponent), canActivate: [roleGuard('admin')] },
      { path: 'aftercare/actions',   loadComponent: () => import('./modules/main/aftercare/actions/actions.component').then(m => m.AftercareActionsComponent), canActivate: [roleGuard('admin')] },
      { path: 'aftercare/sessions',  loadComponent: () => import('./modules/main/aftercare/sessions/sessions.component').then(m => m.AftercareSessionsComponent), canActivate: [roleGuard('admin')] },
      { path: '**', redirectTo: 'appointments' }
    ]
  },
  { path: '**', redirectTo: 'appointments' }
];
